import { useEffect } from 'react';
import { BASE_ROUTES } from 'core/common/constants';
import { useConfig, useServices, useUrlLocation } from 'core/common/hooks';
import { redirectToUrl } from 'core/common/utils/redirectToUrl';

export const PrivacyPolicy = () => {
  const config = useConfig();
  const { analyticsService } = useServices();
  const { previousLocation } = useUrlLocation();

  useEffect(() => {
    analyticsService.techPageOpened(BASE_ROUTES.PRIVACY_POLICY, previousLocation);
    redirectToUrl(config.techLinks.privacyPolicy);
  }, [config.techLinks.privacyPolicy, analyticsService, previousLocation]);

  return null;
};
